import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { msaCreditStatById } from 'redux/saga/entities/bound';
import { MsaOfferProduct } from './MsaOfferProduct';

export class TrialProduct extends MsaOfferProduct {
  static key = 'TrialProduct';

  static *loadCreditStat(client, msa) {
    try {
      yield call(fetchEntityIfNeeded, msaCreditStatById, [client, msa.id]);
    } catch (err) {
      yield call(logger.warn, `Failed to find credit stat for msa [${msa.id}]`, err);
    }
  }

  static *loadPurchaseData(client) {
    const { msaOfferId } = yield call(TrialProduct.getProductData);
    const msaOffer = yield call(TrialProduct.loadOffer, client, msaOfferId);

    if (msaOffer) {
      const { msa } = msaOffer;
      yield all([call(TrialProduct.loadCreditStat, client, msa), call(super.loadPurchaseData, client)]);
    }
  }
}
